import { render, staticRenderFns } from "./CompositionStep1.vue?vue&type=template&id=6e270be7&"
import script from "./CompositionStep1.vue?vue&type=script&lang=js&"
export * from "./CompositionStep1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports